import EventBus from '../../../shared/js/wirebox/event-bus'

EventBus.subscribe('cookies.accepted', () => {
    
    if (typeof tidioUrl == 'undefined' || !tidioUrl) {
        return
    }
    
    const elem = document.createElement('script')
    elem.setAttribute('src', tidioUrl)
    elem.async = true
    /*elem.onload = () => {
        EventBus.publish('tidio.loaded')
    }*/
    document.body.appendChild(elem)
    
})